import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';

import { Popover, PopoverActionsBar  } from "@progress/kendo-react-tooltip";
import { Button } from "@progress/kendo-react-buttons";

export default function HelpPopup({ text, cssClass, showOnHover = true }) {
	
	const anchor = useRef(null);
	const [show, setShow] = useState(false);
	
	const handleOnMouseOver = () => {
		if (!showOnHover) return;
		setShow(true);
	};
	
	const handleOnClick = () => {
		setShow(true);
	}
	
	const closePopup = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setShow(false);
	};
	
	return (
		<span 
			className="fa fw fa-help-circled" 
			onMouseOver={handleOnMouseOver} 
			onClick={handleOnClick}
			ref={anchor}
		>
		{show && createPortal(
			<>
                <div className="k-overlay" style={{ zIndex: 11000 }} />
				<Popover
					show={show}
					anchor={anchor.current}
					className={cssClass}
					position={"right"}
					collision={{ horizontal: "flip", vertical: "fit" }}
			        animate={false}
            		style={{
              			zIndex: 11000,
              			maxHeight: "calc(100vh - 24px)"
            		}}
				>
					{text}
					<PopoverActionsBar
					 	alignment="end"
					>
						<Button 
							onClick={closePopup} 
							fillMode="flat" 
						>
							{"Close"}
						</Button>
					</PopoverActionsBar> 
				</Popover>
			</>,
			document.body
		)}
		</span>
	);
}